import { ChangeEvent, useEffect, useState } from 'react'

import { Field, useFormikContext } from 'formik'

import BlobIcon from '@totallymoney/ui/components/BlobIcon'
import Box from '@totallymoney/ui/components/Box'
import Row from '@totallymoney/ui/components/Row'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

import FormikSelectField from '@components/form/FormikSelectField'

import { loanTermOptions } from '@config/loanTermOptions'

import {
    convertMonthToYear,
    convertYearToMonth,
} from '@utils/loanDetailsFormUtils'

const FormikLoanTermSelect = () => {
    const {
        setFieldValue,
        values: { loanTerm },
    } = useFormikContext<{
        loanTerm: string
    }>()

    const [loanTermInYears, setLoanTermInYears] = useState<string | undefined>(
        loanTerm ? convertMonthToYear(loanTerm) : undefined
    )

    useEffect(() => {
        if (loanTerm) {
            setLoanTermInYears(convertMonthToYear(loanTerm))
        }
    }, [loanTerm])

    return (
        <Stack space="space10">
            <Field
                component={FormikSelectField}
                labelText="How long do you want to repay the loan?"
                name="loanTerm"
                options={loanTermOptions}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setFieldValue(
                        'loanTerm',
                        convertYearToMonth(e.target.value)
                    )
                }
                value={loanTermInYears}
            />

            <Row space="space10">
                <Box justifyContent="flex-start" aria-hidden="true">
                    <BlobIcon blobName="lightBulb" size={40} />
                </Box>

                <Text color="light">
                    <b>Tip:</b> Repaying over a longer time means lower monthly
                    repayments, but could mean you pay more in interest.
                </Text>
            </Row>
        </Stack>
    )
}

export default FormikLoanTermSelect
